import { throttle } from '@cian/newbuilding-utils';

import { useEffect, useRef, useState } from 'react';

import { TabDataCollectionModel } from '../models/TabDataCollectionModel';

export function useHeaderTabsController(selector: string, defaultAnchor: string): [string, TabDataCollectionModel] {
  const [activeTab, setActiveTab] = useState<string>(defaultAnchor);
  const tabDataCollection = useRef<TabDataCollectionModel>(new TabDataCollectionModel([]));

  useEffect(() => {
    tabDataCollection.current.setListByClauses = Array.from(document.querySelectorAll(selector));

    const anchor = window.location.hash || `#${defaultAnchor}`;
    const slug = anchor.slice(1);

    setActiveTab(slug);

    const update = throttle<VoidFunction>(500, () => {
      const activeTabData = tabDataCollection.current.getActiveTab();

      if (activeTabData) {
        setActiveTab(activeTabData.value);
      }
    });

    window.addEventListener('scroll', update);

    return () => {
      window.removeEventListener('scroll', update);
    };
  }, [defaultAnchor, selector]);

  return [activeTab, tabDataCollection.current];
}
